import React, { Component } from "react";
import { arrayOf, bool, objectOf, shape, string } from "prop-types";

import LapseSubOption from "pages/forms/_components/_scheduler/LapseSubOption";
import { Col } from "react-bootstrap";
import { Field } from "formik";
import DateField from "pages/_components/fields/DateField";
import * as schedulerUtils from "util/scheduler";
import * as dateUtils from "util/date";
import * as i18nUtils from "util/i18n";
import moment from "moment";
import { getInteger } from "util/config";

const FORM_ID = "scheduler";

class CommonFrequencySubOption extends Component {
    static propTypes = {
        enabledWeekDays: arrayOf(bool),
        errors: objectOf(string),
        nonWorkingDays: arrayOf(bool),
        lapse: shape({
            day: string,
        }).isRequired,
        frequency: string.isRequired,
        startsOn: string.isRequired,
    };

    static defaultProps = {
        errors: null,
        enabledWeekDays: [],
        nonWorkingDays: [],
    };

    obtainMaxDate = () => {
        const { frequency, lapse } = this.props;
        const withLimits = [schedulerUtils.DAY, schedulerUtils.WEEK, schedulerUtils.MONTH];
        const hasLapse = lapse?.lapse === "UNTIL" && withLimits.includes(frequency);
        const maxDays = getInteger("time.frecuency.max.days", 365);
        const maxDate = hasLapse ? lapse?.date : moment().add(maxDays, "days");
        return maxDate;
    };

    render() {
        const { frequency, lapse, startsOn, enabledWeekDays, nonWorkingDays, errors } = this.props;

        return (
            <>
                <Col sm={12} md={8} mdOffset={2}>
                    <Field
                        component={DateField}
                        autoComplete="off"
                        idForm={FORM_ID}
                        name="startsOn"
                        minDate={dateUtils.setMidnight(startsOn)}
                        maxDate={this.obtainMaxDate()}
                        dateFormat={dateUtils.FRIENDY_DATE_FORMAT(i18nUtils.getLang())}
                        idField="startsOn.date"
                        allowNullValue={false}
                        noEdit
                    />
                </Col>
                {frequency !== schedulerUtils.ONCE && (
                    <Col sm={12} md={8} mdOffset={2}>
                        <div className="scheduler-frequency-suboptions">
                            <Field
                                name="lapse"
                                component={LapseSubOption}
                                enabledWeekDays={enabledWeekDays}
                                errors={errors}
                                firstWorkingDate={startsOn}
                                nonWorkingDays={nonWorkingDays}
                                value={lapse}
                                frequency={frequency}
                            />
                        </div>
                    </Col>
                )}
            </>
        );
    }
}

export default CommonFrequencySubOption;
